<template>
  <image-header-page :image-header-props="imageHeaderProps">
    <template v-slot:header>
      <slot name="header"/>
    </template>
    <template v-slot:overlayContent>
      <card class="header-card" :has-content-padding="false">
        <slot name="dashboard"/>
      </card>
    </template>
    <slot/>
  </image-header-page>
</template>

<script>
import ImageHeaderPage from './ImageHeaderPage.vue';
import Card from '../components/Card/Card.vue';
import { ImageHeaderProps } from '../components/ImageHeader.vue';

export default {
  name: 'DashboardPage',
  components: {
    ImageHeaderPage,
    Card,
  },
  props: {
    imageHeaderProps: ImageHeaderProps,
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/riseup-colors";

.header-card {
  background: $riseup_white;
  color: $riseup_black;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
